import {
    CopyOutlined,
    EnvironmentFilled,
    LinkOutlined,
} from "@ant-design/icons";
import { App, Button, Flex, Image } from "antd";
import { type FC, type ReactNode, useMemo } from "react";
import { Point } from "tm-shared/types";

import { pointToCopy } from "@/domains/point";
import { PrimaryText } from "@/shared/ui/Typography";
import { copyObjectToClipboard } from "@/utils/dom/copyObjectToClipboard";
import { getFileUrl } from "@/utils/file/getFileUrl";

import {
    StyledCard,
    StyledCardContent,
    StyledChainIndicator,
    StyledImgWrapper,
} from "./Styled";

export interface PointCardBaseProps {
    point: Point;
    status?: "archived" | "hasRoutes" | null;
    isChild?: boolean;
    slot?: ReactNode;
}

export const PointCardBase: FC<PointCardBaseProps> = ({
    point,
    status,
    isChild,
    slot,
}) => {
    const { notification } = App.useApp();

    const {
        title,
        name,
        market: { building },
    } = point;

    const handleOpenPointMap = () => {
        const currentAddress = building?.geo ?? building.address?.name;

        window.open(
            `https://www.google.com/maps/place/${currentAddress?.replace(
                /\s/gi,
                "+",
            )}`,
        );
    };

    const normalizePointToCopy = useMemo(() => pointToCopy(point), [point]);

    return (
        <StyledCard $status={status ?? undefined}>
            {isChild && (
                <StyledChainIndicator>
                    <LinkOutlined />
                </StyledChainIndicator>
            )}

            <StyledCardContent>
                <Flex align="center" gap={10}>
                    <StyledImgWrapper>
                        <Image src={getFileUrl(building.photo)} />
                    </StyledImgWrapper>

                    <Button
                        onClick={handleOpenPointMap}
                        type="text"
                        icon={<EnvironmentFilled style={{ fontSize: 22 }} />}
                    />

                    <Button
                        onClick={() =>
                            copyObjectToClipboard(
                                normalizePointToCopy,
                                notification,
                            )
                        }
                        type="text"
                        icon={<CopyOutlined style={{ fontSize: 22 }} />}
                    />

                    {status === "archived" && (
                        <PrimaryText
                            textColor="error"
                            style={{ marginLeft: "auto" }}
                        >
                            Архівна
                        </PrimaryText>
                    )}
                </Flex>

                <Flex vertical gap={4}>
                    {title && (
                        <PrimaryText textColor="disabled">{title}</PrimaryText>
                    )}

                    <PrimaryText textColor="disabled">{name}</PrimaryText>
                </Flex>

                {slot}
            </StyledCardContent>
        </StyledCard>
    );
};
